/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCustomerJoinedAtRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/get_customer_joined_at.pb'
import {GetCustomerJoinedAtResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/get_customer_joined_at.pb'


export const getCustomerJoinedAt = (request: GetCustomerJoinedAtRequest, options?: CashRequestOptions) => post<GetCustomerJoinedAtRequest, GetCustomerJoinedAtResponse>("/2.0/cash/get-customer-joined-at", request, {...options, rejectOnError: true })